import { __awaiter, __extends, __generator } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, Text, View, ActivityIndicator } from 'react-native';
var MotivationalQuote = /** @class */function (_super) {
  __extends(MotivationalQuote, _super);
  function MotivationalQuote(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      loaded: false,
      text: '',
      author: ''
    };
    return _this;
  }
  MotivationalQuote.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, host, locale, response, data;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.props, host = _a.host, locale = _a.locale;
            return [4 /*yield*/, fetch(host + "/api/motivational_quotes.json?locale=" + locale, {
              method: 'GET',
              headers: {
                'Accept-Version': 'application/vnd.api.v15',
                'Content-Type': 'application/json'
              }
            })];
          case 1:
            response = _b.sent();
            return [4 /*yield*/, response.json()];
          case 2:
            data = _b.sent();
            this.setState({
              loaded: true,
              text: data.quote,
              author: data.author
            });
            return [2 /*return*/];
        }
      });
    });
  };
  MotivationalQuote.prototype.render = function () {
    var _a = this.state,
      loaded = _a.loaded,
      text = _a.text,
      author = _a.author;
    if (!loaded) {
      return React.createElement(View, {
        style: styles.container
      }, React.createElement(ActivityIndicator, null));
    }
    return React.createElement(View, {
      style: styles.container
    }, React.createElement(Text, {
      style: styles.quote
    }, text, " \u2013 ", author));
  };
  MotivationalQuote.propTypes = {
    host: PropTypes.string,
    locale: PropTypes.string
  };
  return MotivationalQuote;
}(React.Component);
export { MotivationalQuote };
var styles = StyleSheet.create({
  container: {
    display: 'flex',
    flex: 1
  },
  quote: {
    fontStyle: 'italic'
  }
});